var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessthan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#15D4BE",
    width: "800px",
    height: "800px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#15D4BE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.9999 51.9063 C 41.0546 51.9063 51.9063 41.0781 51.9063 28 C 51.9063 14.9453 41.0312 4.0937 27.9765 4.0937 C 14.8983 4.0937 4.0937 14.9453 4.0937 28 C 4.0937 41.0781 14.9218 51.9063 27.9999 51.9063 Z M 27.9999 47.9219 C 16.9374 47.9219 8.1014 39.0625 8.1014 28 C 8.1014 16.9609 16.9140 8.0781 27.9765 8.0781 C 39.0155 8.0781 47.8983 16.9609 47.9219 28 C 47.9454 39.0625 39.0390 47.9219 27.9999 47.9219 Z M 34.0234 37.6094 C 35.1483 37.6094 35.9687 36.7890 35.9687 35.7344 C 35.9687 34.8437 35.5936 34.3047 34.6093 33.8359 L 22.7265 28 L 22.7265 27.8594 L 34.6093 21.9063 C 35.5702 21.4141 35.9687 20.8516 35.9687 20.0078 C 35.9687 18.9531 35.1718 18.1563 34.0702 18.1563 C 33.5546 18.1563 33.2733 18.2266 32.8983 18.4141 L 18.9296 25.9609 C 17.9921 26.4531 17.5468 27.1328 17.5468 28.0234 C 17.5468 28.9844 17.9452 29.5703 18.9296 30.0859 L 32.8983 37.3281 C 33.2499 37.5156 33.5546 37.6094 34.0234 37.6094 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessthan);
export default __webpack_public_path__ + "static/media/lessthan.e6cb85f82f6c3bd6a05de7628869f5ec.svg";
export { ForwardRef as ReactComponent };